import React from 'react';
import { jsx as _jsx } from 'react/jsx-runtime';

interface ApplePayButtonProps {
    ref?: React.RefObject<null>;
    buttonStyle: 'black' | 'white' | 'white-with-line';
    type:
        | 'pay'
        | 'plain'
        | 'buy'
        | 'set-up'
        | 'donate'
        | 'check-out'
        | 'book'
        | 'subscribe'
        | 'reload'
        | 'add-money'
        | 'top-up'
        | 'order'
        | 'rent'
        | 'support'
        | 'contribute'
        | 'tip';
    locale?: string;
    style?: React.CSSProperties | undefined;
}

export function ApplePayButton({ ref, buttonStyle, type, style }: ApplePayButtonProps) {
    // @ts-expect-error
    return _jsx('apple-pay-button', {
        id: 'tap-apple-pay-button',
        ref,
        buttonStyle,
        type,
        style,
    });
}
